export default __webpack_public_path__ + "static/media/dash_3.09d6785f.png";